export function extractYouTubeId(url: string): string | null {
  if (!url) return null;
  try {
    const u = new URL(url);
    if (u.hostname === "youtu.be") {
      const id = u.pathname.slice(1);
      return id || null;
    }
    if (u.hostname === "www.youtube.com" || u.hostname === "youtube.com") {
      if (u.searchParams.has("v")) {
        return u.searchParams.get("v");
      }
      const match = u.pathname.match(/^\/(shorts|embed)\/([^/?]+)/);
      if (match) return match[2];
    }
    return null;
  } catch {
    return null;
  }
}
